import { render, staticRenderFns } from "./BaseInputSelect.vue?vue&type=template&id=dcd22f00&scoped=true&"
import script from "./BaseInputSelect.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSelect.vue?vue&type=style&index=0&id=dcd22f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd22f00",
  null
  
)

export default component.exports